import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const UslugiPage = lazy(() => import('../pages/uslugi/page'));
const RealizacjePage = lazy(() => import('../pages/realizacje/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const ProcesPage = lazy(() => import('../pages/proces/page'));
const PakietyPage = lazy(() => import('../pages/pakiety/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ONasPage = lazy(() => import('../pages/o-nas/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/uslugi',
    element: <UslugiPage />,
  },
  {
    path: '/realizacje',
    element: <RealizacjePage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/proces',
    element: <ProcesPage />,
  },
  {
    path: '/pakiety',
    element: <PakietyPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/o-nas',
    element: <ONasPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
